import { useContext, type FC } from 'react';
import type { TermStructureProps } from './types';
import TermStructureContent from './term-structure-content';
import { Widget } from '../../widget';
import Source from '../../source';
import { VolSmileContext } from '../../../../providers/widgets';
import TokenSelector from '../../token-selector';
import WidgetButtons from '../../widget-buttons';
import { CurrencyTypeEnum, VolSurfaceToken } from '../../../../model/currency_type.enum';

const TermStructureWidget: FC<TermStructureProps> = (props) => {
  const { widget, actions } = props;
  const { token, setToken, hasDefaultToken } = useContext(VolSmileContext);
  const handleSetToken = (value: VolSurfaceToken) => setToken(value as CurrencyTypeEnum);

  return (
    <Widget cardKey={widget.key}>
      <Widget.Header>
        <Widget.Title title={widget.title} />
        <Widget.HeaderPanel>
          {<TokenSelector token={token} setToken={handleSetToken} isFixedToken={hasDefaultToken} />}
        </Widget.HeaderPanel>
        <Widget.Buttons>
          <WidgetButtons widget={widget} actions={actions} permissions={props.permissions} />
        </Widget.Buttons>
      </Widget.Header>
      <Widget.Content>
        <TermStructureContent providerKey={props.providerKey} />
      </Widget.Content>
      <Widget.Footer>
        <Source source="Deribit" url="https://www.deribit.com" />
      </Widget.Footer>
    </Widget>
  );
};

export default TermStructureWidget;
